import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useSearchPlayerBonuses = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.ISearchPlayerBonusesRequestData): Promise<Types.ISearchPlayerBonusesResponseData> => {
            const { data } = await send<Types.ISearchPlayerBonusesRequestData, Types.ISearchPlayerBonusesResponseData>({
                ID: 31863,
                responses: [31864, 31865],
                description: 'Search Player Bonuses',
                errorLevel: 1,
                ...request
            });

            return data;
        }, [
            send
        ]);
};
